var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Redirection vers Toucan")]),(_vm.erreur)?_c('div',[_c('h3',[_vm._v("Une erreur est survenue")]),_c('p',[_vm._v(_vm._s(_vm.message))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }